import { Component, computed } from '@angular/core';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { DataService } from 'src/app/services/data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { IBudgetantragVerlauf } from 'src/app/types/IBudgetantragVerlauf';

@Component({
  selector: 'app-budget-verlauf',
  standalone: false,
  templateUrl: './budget-verlauf.component.html',
  styleUrl: './budget-verlauf.component.css'
})

export class BudgetVerlaufComponent {

  public dataVerlauf = computed<IBudgetantragVerlauf[] | null>(() => this.dataService.budgetantragVerlauf());

  constructor(private dataService: DataService,
	          public navigationService: NavigationService
  ) {
  
  }
 
  onContentReady(e: DxDataGridTypes.ContentReadyEvent) {
    const rowIndexes = e.component.getVisibleRows().map((row, index) => index);
    rowIndexes.forEach(index => {
      const rowData = e.component.getVisibleRows()[index].data;
      if (rowData.anmerkung) {
        e.component.expandRow(e.component.getKeyByRowIndex(index));
      }
    });
  }

  onFileShowButtonClick(e: IBudgetantragVerlauf): void {
    if (e.dateiNameAnhang && e.dateiNameAnhang != '') {
      // load file 
      this.dataService.readFreigabeAnhang(e.budgetantragID, e.vonStufe!).subscribe({
        next: (data: any) => {
          if (data) {
            var file = new File([data], e.dateiNameAnhang!, { type: data.type });
            var url = URL.createObjectURL(file!);
            window.open(url, '_blank');            
          }
       }  
      });
    }
  }

}
